import React from 'react';
import { styled } from '@mui/material/styles';
import { GivelifyButton } from '../button';

type SubmitFooterProps = {
    onCancel: () => void;
    cancelText: string;
    onSubmit: () => void;
    submitText: string;
    disableSubmit?: boolean;
    isLoading?: boolean;
    testId?: string;
};

const FooterContainer = styled('div')(({ theme }) => ({
    boxSizing: 'border-box',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingRight: 80,
    [theme.breakpoints.down('xs')]: {
        paddingRight: 16,
        paddingLeft: 16,
        justifyContent: 'center',
    },
}));

const CancelButton = styled(GivelifyButton)(({ theme }) => ({
    marginRight: 12,
    minWidth: 160,
    [theme.breakpoints.down('xs')]: {
        width: '100%',
        marginRight: 8,
        minWidth: 'initial',
        height: 36,
    },
}));

const SubmitButton = styled(GivelifyButton)(({ theme }) => ({
    marginLeft: 12,
    minWidth: 170,
    [theme.breakpoints.down('xs')]: {
        width: '100%',
        marginLeft: 8,
        minWidth: 'initial',
        height: 36,
    },
}));

export const SubmitFooter: React.FunctionComponent<SubmitFooterProps> = (
    props,
) => {
    const {
        onCancel,
        onSubmit,
        cancelText,
        submitText,
        disableSubmit,
        isLoading,
        testId,
    } = props;
    return (
        <FooterContainer id="submit-footer">
            <CancelButton
                data-testid={testId && `${testId}Cancel`}
                name="cancel"
                onClick={onCancel}
                size="small"
                text={cancelText}
            />
            <SubmitButton
                data-testid={testId && `${testId}Submit`}
                disabled={disableSubmit}
                isLoading={isLoading}
                name="submit"
                onClick={onSubmit}
                size="small"
                text={submitText}
                variant="primary"
            />
        </FooterContainer>
    );
};
